import obaxios from '@/utils/obaxios'
//登录
const login = function ({ username, password }) {
  return obaxios({
    method: 'post',
    url: '/task/login/',
    data: { username, password },
  })
}

// 退出登录
const logout = function () {
  return obaxios({
    method: 'post',
    url: '/task/logout/',
  })
}

// 注册
const register = function ({ username, email, phone, password1, password2 }) {
  return obaxios({
    method: 'post',
    url: '/task/register/',
    data: { username, email, phone, password1, password2 },
  })
}

// 验证邮箱
const validate_email = function ({ vcode }) {
  return obaxios({
    method: 'get',
    url: '/task/validate_email/',
    params: { vcode },
  })
}

// 重制密码1
const reset_password_one = function ({ email }) {
  return obaxios({
    method: 'post',
    url: '/task/reset_password_one/',
    data: { email },
  })
}

// 重制密码2
const reset_password_two = function ({ password, vcode }) {
  return obaxios({
    method: 'post',
    url: '/task/reset_password_two/',
    data: { password, vcode },
  })
}

// 修改密码
const change_password = function ({ password }) {
  return obaxios({
    method: 'post',
    url: '/task/change_password/',
    data: { password },
  })
}

export { login, register, logout, validate_email, reset_password_one, reset_password_two, change_password }
